export var PAGE_NAME = {
    ERROR: "error",
    VIEW: "view",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "dashboard",
    PAGE_NAME: PAGE_NAME.VIEW,
    SITE_IDENTIFIER: "vista",
    DEVICE: "<desk/mobi/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    MESSAGE_TYPE: "",
    MESSAGE: "",
    PAGE_KIND: "multiaccount",
    PREVIOUS_PAGE: "",
};
export var PAGE_SUBFUNCTIONS = {
    LOAN_NICKNAME: "loan nickname",
};
export var ERRORS = {
    ERROR_MESSAGE: "Something went wrong",
    API_FAILURE: "api failure",
};
export var PAGE_INFO_PROPS = {
    ClientName: "ClientName",
    Country_Language: "Country_Language",
    CustomerType: "CustomerType",
    ErrorMessage: "ErrorMessage",
    MessageType: "MessageType",
    PageFunction: "PageFunction",
    PageKind: "PageKind",
    pageName: "pageName",
    PageSubFunction: "PageSubFunction",
    PNL: "PNL",
    Product: "Product",
    SiteIdentifier: "SiteIdentifier",
    Token: "Token",
    numberofaccounts: "numberofaccounts",
};
//# sourceMappingURL=analytics.js.map